import { ClickAwayListener, Menu } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { GridTripleDotsVerticalIcon } from '@mui/x-data-grid-pro'
import type { MouseEvent } from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import ManuallyAcceptOption from '@/features/bidding/components/overview/bidsMenu/options/ManuallyAcceptOption'
import ManuallyEditOption from '@/features/bidding/components/overview/bidsMenu/options/ManuallyEditOption'
import type { Status } from '@/features/bidding/constants'
import type { GroupedBidParams } from '@/features/bidding/utils/groupedBidParams/buildBiddingLinks'

interface BidsMenuProps {
  groupedBidParams: GroupedBidParams
  statuses: Status[]
}

const BidsMenu = ({ groupedBidParams, statuses }: BidsMenuProps) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState<boolean>(false)
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleOptionsClick = (event: MouseEvent<HTMLElement>) => {
    event.preventDefault()
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
    setOpen(true)
  }

  const handleOptionsClose = (event: { preventDefault: () => void; stopPropagation: () => void }) => {
    event.preventDefault()
    event.stopPropagation()
    setAnchorEl(null)
    setOpen(false)
  }

  return (
    <>
      <ClickAwayListener onClickAway={handleOptionsClose}>
        <IconButton
          aria-controls="simple-menu"
          aria-haspopup="true"
          aria-label={t('bidding.options.more_actions')}
          data-testid="menu-button"
          title={t('bidding.options.more_actions')}
          onClick={handleOptionsClick}
        >
          <GridTripleDotsVerticalIcon />
        </IconButton>
      </ClickAwayListener>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        open={open}
        onClose={handleOptionsClose}
      >
        <ManuallyAcceptOption groupedBidParams={groupedBidParams} statuses={statuses} />
        <ManuallyEditOption groupedBidParams={groupedBidParams} statuses={statuses} />
      </Menu>
    </>
  )
}

export default BidsMenu
